
/* @flow */
import React from 'react';
import InvoiceToolSelectVacationInformationModal from './invoice-tool-select-vacation-information-modal';

export class VacationInformationButton extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      vacationInformationModalIsOpen: false
    };

    this.openVacationInformationModal = this.openVacationInformationModal.bind(this);
    this.setVacationInformationModal = this.setVacationInformationModal.bind(this);
  }

  openVacationInformationModal (e) {
    e.preventDefault();
    this.setVacationInformationModal(true);
  }

  setVacationInformationModal (value) {
    this.setState({
      vacationInformationModalIsOpen: value
    });
  }

  render () {
    return <button
      className='tooltip-info-button'
      onClick={this.openVacationInformationModal}>
      <InvoiceToolSelectVacationInformationModal
        isOpen={this.state.vacationInformationModalIsOpen}
        toggleModal={this.setVacationInformationModal}
      />
    </button>;
  }
}

export default VacationInformationButton;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/complete-information-modal/vacation-information-button.js
 **/